import axios from "axios";
import Cta from '../Cta';
import Hero from '../Hero';
import Section from '../Section';
import a3 from "../Images/a3.jpeg";
import bg1 from "../Images/bg1.jpg";
import a24 from "../Images/a24.png";
import Carousal from "../../Carousal";
import clinic from "../Images/clinic.webp";
import ctabg from "../Images/home_1/ctabg.svg"
import constants from "../../GlobalConstants";
import MednaBrand from "../../config/MednaBrand";
import homebg32 from "../Images/bg/homebg32.jpg";
import hospitalBg from "../Images/bg/defocus-image-of-doctors-and-radiologist-adjusting-2025-01-29-08-18-07-utc.jpg";
import AwardSection from '../Section/AwardSection';
import AboutSection from '../Section/AboutSection';
import { pageTitle } from '../../helpers/PageTitle';
import mednalogo from "../Images/bg/mednalogo.png";
import generalvideo from "../Images/generalvideo.mp4";
import healthcarebg from "../Images/bg/healthcarebg.jpg"
import AppointmentSection from '../Section/AppointmentSection';
import { checkEmpty, headerData } from "../../GenericFunctions";
import FeaturesSectionStyle4 from '../Section/FeaturesSection/FeaturesSectionStyle4';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';

import React, { useEffect, useState } from "react";

const featureListData1 = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Engineered for Emirati Healthcare Excellence ',
    subTitle: `
    <ul>
      <li>Cloud or On-Premise </li>
      <li>Multilingual interface (English + regional)</li>
      <li>Mobile Apps for Doctors & Admins  </li>
      <li>Role-Based Security</li>
      <li>Smart Analytics & KPIs</li>
    </ul>
    <p class="tech-text">Technology that simplifies — not complicates — healthcare.</p>
  `,
    iconUrl: 'images/icons/professional.svg',
  },
];


const featureListData = [
  {
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/value_icon_1.svg',
    title: 'Health Bubble',
    subTitle:
      'Tool that provides doctor to manage patients with artificial intelligence,' +
      'notification and manage productivity of hospital staff.' +
      'Bubble Health is committed to helping healthcare organizations deliver value-based.'
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/value_icon_2.svg',
    title: 'Patient Engagement',
    subTitle:
      'Patient centric app that empowers patient to manage their family health and passively report health events,' +
      'Bubble health is one stop for your health solutions.'
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/value_icon_3.svg',
    title: 'Re-Invent Your Practice',
    subTitle: 'ERP for your practice, digitalize your clinical information,' +
      'Analyze, Treat and monitor your patient under health bubble efficiently.'
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/value_icon_4.png',
    title: 'Respect',
    subTitle:
      'We treat all individuals with respect and dignity, regardless of their background, beliefs,' +
      'or circumstances.We believe that every person deserves to be treated with compassion and kindness.',
  },
  {
    iconUrl: process.env.PUBLIC_URL + '/images/home_3/value_icon_5.png',
    title: 'Teamwork',
    subTitle:
      'We believe in working collaboratively with our team professionals to provide' +
      'comprehensive and effective care to our clients for our product.',
  },
];
// const brandData = [
//   { imgUrl: 'images/brand_1.png', imgAlt: 'Brand' },
//   { imgUrl: 'images/brand_2.png', imgAlt: 'Brand' },
//   { imgUrl: 'images/brand_3.png', imgAlt: 'Brand' },
//   { imgUrl: 'images/brand_4.png', imgAlt: 'Brand' },
//   { imgUrl: 'images/brand_5.png', imgAlt: 'Brand' },
//   { imgUrl: 'images/brand_6.png', imgAlt: 'Brand' },
//   { imgUrl: 'images/brand_7.png', imgAlt: 'Brand' },
//   { imgUrl: 'images/brand_8.png', imgAlt: 'Brand' },
// ];


const brandData = (clientList) => {
  console.log("clientList", clientList);

  if (clientList && clientList.length > 0) {
    clientList = clientList.filter(fItem => (!checkEmpty(fItem.logo)))
    clientList.forEach(el => {
      el.imgUrl = el.logo
      el.imgAlt = 'Brand'
    })
    return clientList.map((item) => ({
      imgUrl: item.imgUrl,
      imgAlt: item.imgAlt || "Brand",
    }));
  }
}


const faqData = [
  {
    title: 'What services does ProHealth offer?',
    content:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
  },
  {
    title: 'How do I schedule an appointment with ProHealth?',
    content:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
  },
  {
    title: 'Do you accept insurance?',
    content:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
  },
  {
    title: 'What should I bring to my appointment?',
    content:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
  },
  {
    title: 'How do I request a prescription refill?',
    content:
      'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
  },
];
const blogData = [
  {
    title: 'The Benefits of Mindfulness Meditation for Stress and Anxiety',
    thumbUrl: 'images/home_1/post_1.jpeg',
    date: 'May 1, 2023',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'Healthy Eating on a Budget: Tips and Strategies',
    thumbUrl: 'images/home_1/post_2.jpeg',
    date: 'May 4, 2023',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
  {
    title: 'The Importance of Regular Cancer Screenings and Early Detection',
    thumbUrl: 'images/home_1/post_3.jpeg',
    date: 'May 1, 2023',
    btnText: 'Learn More',
    href: '/blog/blog-details',
    socialShare: true,
  },
];
const awardData = [
  {
    title: "* Hospital Management",
    subTitle:
      'A Hospital Management Software (HMS) streamlines operations by digitizing and automating' +
      ' tasks like patient registration, appointment scheduling, billing, and medical records, thereby ' +
      'improving efficiency and patient care quality.,',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Clinic & Polyclinic",
    subTitle:
      'Clinic and polyclinic management software is an integrated solution designed to streamline' +
      'all administrative, clinical, and financial operations of healthcare facilities.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Laboratory & Diagnostics",
    subTitle:
      'Laboratory & Diagnostics management software is a digital solution designed to automate' +
      'and streamline a labs entire workflow from patient registration and sample tracking to report' +
      'generation and billing.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Pharmacy & Inventory",
    subTitle:
      'Pharmacy & Inventory management software automates the entire medication workflow,' +
      'from purchasing and stocking to billing and dispensing, thereby improving efficiency' +
      ' and ensuring regulatory compliance.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Finance & Accounting ",
    subTitle:
      ' Finance & Accounting management software automates the recording, processing, and reporting' +
      ' of financial transactions to streamline operations and ensure compliance.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Analytics & Business Intelligence",
    subTitle:
      'Analytics & Business Intelligence (BI) software helps organizations collect and analyze large' +
      ' amounts of data to uncover meaningful patterns and trends.',
    iconUrl: 'images/icons/award.svg',
  },
];


export default function Home() {
  const [clientList, setClientList] = useState([]);
  useEffect(() => {
    const data = {
      loginDataVo: {
        master: 'L',
        config1: 'X1',
        language: 'EN',
        countryID: 'IN',
        getDetails: true,
        popularList: true,
        clientUrl: "docchoice.com",
      }
    };
    axios.post(constants.webServiceURL + "/DocChoiceWebServices/userManagement/getClientPortalList",
      data, { headerData }).then((response) => {
        setClientList(response.data.locationDetailsList);
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  }, []);

  pageTitle('Home');
  return (
    <>
      <Hero
        title="Connecting Healthcare, Technology, and People"
        subTitle="We are committed to providing you with the best medical and healthcare services to help you live healthier and happier."
        bgUrl={homebg32}
        imgUrl={mednalogo}
        infoList={[
          {
            title: 'Call-Us',
            subTitle: '+971507098504',
            iconUrl: process.env.PUBLIC_URL + '/images/contact/icon_1.svg',
          },
          {
            title: 'Location',
            subTitle: 'IFZA Business Park, Dubai Silicon Oasis',
            iconUrl: process.env.PUBLIC_URL + '/images/icons/pin.svg',
          },
        ]}
        btnText="Book Now"
        btnUrl={"/appointments"}
      />
      <Section topMd={60} topLg={50} topXl={40}>
        <AwardSection sectionTitle="A Complete Healthcare ERP Suite — All in One Platform "
          bgUrl={hospitalBg}
          imgUrl={ctabg}
          data={awardData} />
      </Section>
      <Section topMd={60} topLg={50} topXl={40}>
        <FeaturesSectionStyle4
          sectionTitle="Our Values"
          data={featureListData}
        />
      </Section>
      <Section topMd={60} topLg={50} topXl={40}>
        <AboutSection
          imgUrl={a24}
          title="About Us"
          subTitle="Medna Data Systems"


          featureList={[
            {
              featureListTitle:
                'Medna Data Systems is a team of experienced healthcare technology professionals',
              featureListSubTitle:
                'Dedicated to providing top-quality product services.We believe that the main objective of coming out with Complete online Electronic Health Record System and Practice Management Tool for all specialties. ',
            },
          ]}
        />
      </Section>

      <Section topMd={60} topLg={50} topXl={40}>
        <Cta
          title="Powering the Future of Healthcare."
          subTitle="Schedule an demo with one of our experienced support professionals today!"
          bgUrl={healthcarebg}
          btnUrl="/appointments"
          btnText="Booking Now"
        />
      </Section>
      <Section topMd={60} topLg={50} topXl={40}>
        <FeaturesSectionStyle2
          sectionTitle="Features & Technology"
          imgUrl={clinic} height='75%'
          iconUrl={process.env.PUBLIC_URL + '/images/icons/professional.svg'}
          data={featureListData1}
        />
      </Section>
      <Section topMd={60} topLg={50} topXl={40} id="appointment">
        <AppointmentSection
          sectionTitle="Request a Demo"
          imgUrl={a3}
        />
      </Section>
      <Section topMd={60} topLg={100} topXl={40} bottomMd={20} bottomLg={15} bottomXl={10}>
        {/* <div style={{ textAlign: 'center', fontSize: '48px', fontWeight: '600', color: MednaBrand.colors.primary, paddingTop: '40px' }}>
          PARTNERS & CLIENTS </div>
        <div style={{
          textAlign: 'center', fontSize: '24px', fontWeight: '600', color: MednaBrand.colors.accent, padding: '20px 0 60px'
        }}>
          Trusted by Healthcare Providers Across the Region </div>
        <BrandsSection data={brandData(clientList)} />
        <Carousal clientList={clientList} /> */}
      </Section>
    </>
  );
}
